/* @flow */
import apiRequest from 'lib/apiRequest';

const FamilyActions = {
  sendConsentForm(childId: number) {
    return apiRequest('/family/send_vpc_form', 'POST', {
      child_id: childId,
    });
  },
  sendConsentFile(childId: number, consentFileUuid: string) {
    return apiRequest('/family/verify', 'POST', {
      child_id: childId,
      signature_file_uuid: consentFileUuid,
    });
  },
  sendConsentPayment(childId: number, token: string, cardOwnerName: string) {
    return apiRequest('/family/verify', 'POST', {
      child_id: childId,
      charge: {
        token,
        cardowner_name: cardOwnerName,
      },
    });
  },
};

export default FamilyActions;



// WEBPACK FOOTER //
// ./src/actions/FamilyActions.js